/* @flow */

import React from 'react';
import styled from 'styled-components';

import ComplexCard from '../ComplexCard';
import type { TComplexShortItem } from '../../types/complex';

const Root = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
	grid-gap: 20px;
	width: 100%;

	@media (min-width: 1200px) {
		grid-template-columns: repeat(auto-fill, minmax(430px, 1fr));
	}

	@media (max-width: 470px) {
		grid-template-columns: 100%;
	}
`;

type TProps = {
	complexes: TComplexShortItem[],
	onBadgeClick?: () => {},
	rounded?: boolean,
	dataQa?: string,
};

const ComplexCards = ({ complexes, onBadgeClick, rounded, dataQa }: TProps) => (
	<Root>
		{complexes.map((complex) => (
			<ComplexCard
				dataQa={dataQa}
				onBadgeClick={onBadgeClick}
				complex={complex}
				key={complex.id}
				rounded={rounded}
				withShadow
			/>
		))}
	</Root>
);

ComplexCards.defaultProps = {
	onBadgeClick: () => {},
	rounded: false,
	dataQa: null,
};

export default ComplexCards;
